import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import BaseRouter from "./router/index";
// 引入库与持久化工具
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from "./store";
import "dayjs/locale/zh-cn";
import "antd/dist/reset.css";
import "animate.css";
import "./style.css";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor} loading={null}>
      <BaseRouter />
    </PersistGate>
  </Provider>
);
